// src/components/ClientAuthCheck.tsx
"use client";

import { useAuth } from "@/contexts/AuthContext";
import { useEffect } from "react";

export function ClientAuthCheck({ children }: { children: React.ReactNode }) {
  const { isLoading, isAuthenticated, refreshAccessToken } = useAuth();

  // Setup token refresh interval
  useEffect(() => {
    // const token = localStorage.getItem("accessToken");
    // if (token) {
    //   document.cookie = `token=${token}; path=/; max-age=86400; SameSite=Lax`;
    // }

    if (isAuthenticated) {
      // Refresh token every 50 minutes (assuming 1 hour expiry)
      const interval = setInterval(() => {
        refreshAccessToken();
      }, 50 * 60 * 1000);

      return () => clearInterval(interval);
    }
  }, [isAuthenticated, refreshAccessToken]);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return <>{children}</>;
}

// /* eslint-disable @typescript-eslint/no-unused-vars */
// // src/components/ClientAuthCheck.tsx
// "use client";

// import { useAuth } from "@/contexts/AuthContext";
// import { usePathname, useRouter } from "next/navigation";
// import { useEffect, useState } from "react";

// export function ClientAuthCheck({ children }: { children: React.ReactNode }) {
//   const { setToken, setUser, setBusinesses, setCurrentBusiness, setIsLoading } =
//     useAuth();
//   const [isInitialized, setIsInitialized] = useState(false);
//   const router = useRouter();
//   const pathname = usePathname();

//   // Initialize auth state from localStorage
//   useEffect(() => {
//     const init = async () => {
//       try {
//         const storedToken = localStorage.getItem("token");
//         const storedUser = localStorage.getItem("user");
//         const storedBusinesses = localStorage.getItem("businesses");
//         const storedCurrentBusiness = localStorage.getItem("currentBusiness");

//         // Restore token
//         if (storedToken) {
//           setToken(storedToken);

//           // Restore user data
//           if (storedUser) {
//             try {
//               setUser(JSON.parse(storedUser));
//             } catch (e) {
//               console.error("Invalid user data in storage");
//             }
//           }
//         }

//         // Restore businesses
//         if (storedBusinesses) {
//           try {
//             setBusinesses(JSON.parse(storedBusinesses));
//           } catch (e) {
//             console.error("Invalid business data in storage");
//           }
//         }

//         // Restore current business
//         if (storedCurrentBusiness) {
//           try {
//             setCurrentBusiness(JSON.parse(storedCurrentBusiness));
//           } catch (e) {
//             console.error("Invalid current business data in storage");
//           }
//         }

//         // Handle redirects for protected routes
//         const publicRoutes = ["/login", "/register", "/forgot-password"];
//         const isPublicRoute = publicRoutes.includes(pathname);

//         if (!storedToken && !isPublicRoute) {
//           router.push("/login");
//         }
//         // else if (storedToken && pathname === "/") {
//         //   router.push("/dashboard");
//         // }
//       } catch (error) {
//         console.error("Error initializing auth state:", error);
//       } finally {
//         setIsLoading(false);
//         setIsInitialized(true);
//       }
//     };

//     init();
//   }, [
//     setToken,
//     setUser,
//     setBusinesses,
//     setCurrentBusiness,
//     setIsLoading,
//     router,
//     pathname,
//   ]);

//   // Don't render anything until we've initialized auth state
//   if (!isInitialized) {
//     return (
//       <div className="flex h-screen items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
//       </div>
//     );
//   }

//   return <>{children}</>;
// }
